<template>
    <div class="ml-auto">
        <ul class="language__menu list list--horizontal">
            <li class="language__item list__item list__item--horizontal list__item--line"
                v-for="locale in locales">
                <a href="#"
                   class="language__link"
                   :class="{'language__link--active': activeLocale == locale }"
                   v-on:click.prevent="goTo(locale)">
                   {{locale}}
                </a>
            </li>
        </ul>
    </div>
</template>


<script>
    export default {
        name: 'LanguageMenu',
        data: function () {
            return {
                locales: this.$root.locales,
            }
        },
        computed: {
            activeLocale () {
                return this.$store.state.activeLocale
            }
        },
        methods: {
            goTo(locale) {
                let goTo = {name: this.$router.currentRoute.name};
                goTo.params = this.$router.currentRoute.params;
                goTo.params.locale = locale;

                this.$router.push(goTo);
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/modules/components/LanguageMenu.vue